<template>
    <div style="height: calc(100% - 44px);">
        <div style="height: 100%;display: flex;flex-direction: column;">
            <div style="border-bottom: 1px dashed #d9d9d9;" :style="{'height': myComponent.topHeight + 'px','width':'100%'}"
            v-if="myComponent.showTop">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="topComponents"
                    :plist="parentComponents"
                />
            </div>
            <div :style="{'width': '100%','flex-grow': '1'}">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="centerComponents"
                    :plist="parentComponents"
                />
            </div>
            <div style="border-top: 1px dashed #d9d9d9;" :style="{'height': myComponent.bottomHeight + 'px','width':'100%'}"
            v-if="myComponent.showBottom">
                <drag-form-page-wraper
                    ref="dragFormWraper"
                    :select.sync="selectWidget"
                    :componentsList="bottomComponents"
                    :plist="parentComponents"
                />
            </div>
        </div>
      <el-button
        title="复制"
        @click.stop="handleWidgetClone(index)"
        class="drag-table-action-clone"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="primary"
      >
        <i class="el-icon-copy-document"></i>
      </el-button>
      <el-button
        title="删除"
        @click.stop="handleWidgetDelete(index)"
        class="drag-table-action-delete"
        v-if="selectWidget.prop == myComponent.prop"
        circle
        plain
        size="mini"
        type="danger"
      >
        <i class="el-icon-delete"></i>
      </el-button>
    </div>
  </template>
  <script>
  import mixin from "./mixin";
  export default {
    name: "drag-form-horizontal-layout",
    mixins: [mixin()],
    data() {
      return {
        form: {},
      };
    },
    computed: {
      topComponents() {
        return this.myComponent.topComponents;
      },
      centerComponents() {
        return this.myComponent.centerComponents;
      },
      bottomComponents() {
        return this.myComponent.bottomComponents;
      },
      calcHeight(){
        return `calc(100%)`
      },
    },
    methods: {
      handleWidgetClone(index) {
        let cloneData = this.$deepClone(this.myComponent);
        cloneData.prop = Date.now() + "_" + Math.ceil(Math.random() * 99999);
        cloneData.table = "";
        cloneData.field = "";
        this.setAllProp(cloneData.children);
        this.parentComponents.splice(index, 0, cloneData);
        this.$nextTick(() => {
          this.handleSelectWidget(index + 1);
          this.$emit("change");
        });
      },
      handleFormClickAdd(item) {
        console.log(item);
        console.log(this.myComponent);
        // this.childrenComponents.push(item);
        // this.$refs.dragFormWraper.handleFormAdd(
        //   { newIndex: this.childrenComponents.length - 1 },
        //   true
        // );
      },
    },
  };
  </script>
  